import { useDispatch,useSelector} from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
//import { itemsActions } from "../store/itemsSlice";
import { allItemsActions } from "../store/allItemsSlice";
import OrderSummary from "../Components/OrderSummary";
import styles from "../Components/ProductList.module.css";
import OrderSummaryAmount from "../Components/OrderSummaryAmount";
import { Link } from "react-router-dom";
import Api from "../Components/Api";

const PlaceOrder = () => {
  let productQuantity = useSelector(store => store.bag.bagListQuantity);    
  //let productQty = productQuantity.find(el => el.id === item.id);

  let loggedInId = localStorage.getItem('user_id');
  const dispatch = useDispatch();
  const [address, setAddress] = useState({});
  //const shopId = useSelector(store => store.shop);
    useEffect(() => {    
    Api.get(`/all-shops-products`)
        .then((response) => {
            //dispatch(itemsActions.addInitialItems(response.data));
            dispatch(allItemsActions.addInitialItems(response.data));
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
      Api.get(`/customer-details/${loggedInId}/`)
        .then((response) => {
          //console.log(response.data[0])
          setAddress(response.data[0]);
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
    }, []);
  const bagIds = useSelector(store => store.bag.cartList);    
  //const items = useSelector(store => store.items);
  const items = useSelector(store => store.allItems);
  let bagItems = items.filter(item => {
    const itemIndex = bagIds.indexOf(item.id);
    return itemIndex >= 0;
  }) 
  //console.log(productQuantity);
  
    productQuantity.forEach(element => {
      bagItems = bagItems.map((el)=> {
        if(el.id===element.id){
            return {...el, quantity:element.quantity}
        }
        return el
    }); 
      
    });    
  //create here for submit method
    const submit = async (e) => { 
      let finalObj = {};
      bagItems.forEach(element => {
        console.log(element);
        if (element.user_id in finalObj) {
          finalObj[element.user_id].push(element);
         } else {
          finalObj[element.user_id] = [element];
         }
    });
  //console.log(finalObj);
  //console.log('Hello Emad');
    e.preventDefault();
    for (const property in finalObj) {
      console.log(property);
      const orderDetails = {
        customerId: address.id,
        userId: address.user_id,
        shopUserId : property,
        status: 'Open',
        state:address.state,
        city: address.city,
        orderDetails: finalObj[property],//bagItems,//JSON.stringify(bagItems),
        contactDetails: [{address:address.address, state: address.state, city:address.city, pincode:address.pin_code, mobileno:address.mobile_no}],
      };
      //axios.post(`${global.config.live_url}/api/place-order/`, orderDetails,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, withCredentials: true });
      Api.post(`/place-order/`, orderDetails,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, withCredentials: true });
    }
    localStorage.removeItem("cartList")        
    window.location.href = '/placed-order-successfully';
   
  }
    return (
      <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
          <div className="container-fluid">  
            <form onSubmit={submit}>  
              
              <div className="mb-3 row">
              <label className="col-sm-2 col-form-label">Deliver to:</label>
              <div className="col-sm-10">
                <button type="button" className="btn btn-link"><Link to="/address-update">Change</Link></button>
              </div>
            </div>
              

          <div className="mb-3 row">
              <div className="col-sm-12">
                  {address.address}, {address.city}, {address.state}, {address.pin_code}, {address.mobile_no}  
              </div>
            </div>   
            
            <div className="mb-3 row">
              <div className="col-sm-12">
              {bagItems.map((item) => (
                  <OrderSummary key={item.id} item={item} />                
              ))}  
            
              </div>
            </div>  
            <div className="mb-3 row">
              <label for="button" className="col-sm-8 col-form-label"><OrderSummaryAmount /></label>
              <div className="col-sm-4">
                <button type="submit" className="btn btn-success">
                  Place order
                </button>
              </div>
              </div>
              </form>
          </div>
        </div>
      </>
    );

}
export default PlaceOrder